import { render, staticRenderFns } from "./MainTablesTwo.vue?vue&type=template&id=7faf95fb&scoped=true&"
import script from "./MainTablesTwo.vue?vue&type=script&lang=js&"
export * from "./MainTablesTwo.vue?vue&type=script&lang=js&"
import style0 from "./MainTablesTwo.vue?vue&type=style&index=0&id=7faf95fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faf95fb",
  null
  
)

export default component.exports